module.exports = __webpack_public_path__ + "img/Grejanje_COAL.b4c0a678.svg";